import { Button, IconButton, Snackbar } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import cx from 'clsx'
import { useState } from 'react'

const hiddenStyle = { display: 'none' }
export function CopyLinkButton() {
  const [snackbar, setSnackbar] = useState(false)

  const onCopied = () => {
    const targetURL = window.location.href.substr(
      0,
      window.location.href.indexOf('?') > 0
        ? window.location.href.indexOf('?')
        : window.location.href.length
    )
    if (navigator?.clipboard) {
      navigator.clipboard.writeText(targetURL).then(() => {
        return setSnackbar(true)
      })
    } else {
      const copyField = document.createElement('textarea')
      copyField.value = targetURL
      copyField.style.userSelect = 'auto'
      document.body.appendChild(copyField)
      copyField.select()
      document.execCommand('copy')
      copyField.parentNode?.removeChild(copyField)
      return setSnackbar(true)
    }
  }

  const handleClose = () => {
    setSnackbar(false)
  }

  const action = (
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={handleClose}
      className={cx('faq-snackbar-button-copy-link')}
    >
      <Close fontSize="small" className={cx('faq-snackbar-button-icon-copy-link')} />
    </IconButton>
  )

  return (
    <>
      <div className={cx('faq-button-copy-link-wrapper')}>
        <Button
          style={hiddenStyle}
          className={cx('faq-button', 'faq-button-copy-link')}
          onClick={onCopied}
          variant="contained"
          color="secondary"
          size={'small'}
        >
          リンクをコピーする
        </Button>
      </div>
      <Snackbar
        open={snackbar}
        autoHideDuration={6000}
        onClose={handleClose}
        message="クリップボードにコピーしました"
        action={action}
        className={cx('faq-snackbar-copy-link')}
      />
    </>
  )
}
